import { Link } from "react-router-dom";
import { Ship, Plane, Package, Home as HomeIcon, ShieldCheck, Truck, Search, Boxes, ArrowRight } from "lucide-react";

const services = [
  { icon: Ship, title: "Sea Freight (FCL & LCL)", body: "Full Container Load (FCL) and Less than Container Load (LCL) ocean shipping from Vancouver, Toronto and Miami to every English Caribbean port. Reliable weekly sailings.", img: "https://images.unsplash.com/photo-1605745341112-85968b19335b?crop=entropy&cs=srgb&fm=jpg&q=85" },
  { icon: Plane, title: "Air Freight", body: "Express air cargo for time-sensitive shipments — perishables, documents, urgent commercial goods. 3-7 day transit.", img: "https://images.unsplash.com/photo-1571086291540-b137111fa1c7?crop=entropy&cs=srgb&fm=jpg&q=85" },
  { icon: Boxes, title: "Food Barrel Packing", body: "We pack, seal, label and manifest your food barrels and boxes. Bring your goods or have us pick them up — we handle the rest.", img: "https://images.unsplash.com/photo-1664382953403-fc1ac77073a0?crop=entropy&cs=srgb&fm=jpg&q=85" },
  { icon: HomeIcon, title: "Door-to-Door Delivery", body: "Pickup from any address in our coverage area, delivery straight to your receiver's door — fully managed, fully insured." },
  { icon: ShieldCheck, title: "Pre-Clearance", body: "We prepare and submit customs documentation before your shipment arrives so it clears faster on the other side." },
  { icon: Truck, title: "Courier Service", body: "Small parcels and documents shipped via expedited courier to the Caribbean in days, not weeks." },
  { icon: Search, title: "Sourcing & Procurement", body: "Tell us what you need — we'll find it, buy it on your behalf, consolidate with your shipment and ship it." },
  { icon: Package, title: "Consolidation & Warehousing", body: "Short-term warehousing at all three origin hubs. We consolidate multi-shipper LCL to lower your cost per cubic foot." },
];

export default function Services() {
  return (
    <div data-testid="services-page">
      <section className="bg-[#1E2A78] text-white py-20 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-xs font-semibold uppercase tracking-wider text-[#FFD700] mb-3">Our Services</div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-display font-extrabold tracking-tight max-w-3xl">
            Every shipping mode you need, <span className="text-[#FFD700]">under one roof.</span>
          </h1>
          <p className="mt-6 text-slate-200 max-w-2xl text-lg leading-relaxed">
            From a single courier envelope to a 40ft container — Amplartic covers it. Every shipment includes tracking, paperwork support and a real human on every call.
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-px bg-slate-200 border border-slate-200">
            {services.map((s, i) => {
              const Icon = s.icon;
              return (
                <div key={s.title} className="bg-white p-8 lg:p-10 group" data-testid={`service-detail-${i}`}>
                  {s.img && (
                    <div className="mb-6 -m-8 lg:-m-10 mb-6 h-48 overflow-hidden">
                      <img src={s.img} alt={s.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    </div>
                  )}
                  <div className="h-12 w-12 rounded-sm bg-[#FFD700]/20 border border-[#FFD700] flex items-center justify-center mb-5">
                    <Icon className="h-6 w-6 text-[#1E2A78]" />
                  </div>
                  <h3 className="text-2xl font-display font-bold text-[#0F172A]">{s.title}</h3>
                  <p className="mt-3 text-slate-600 leading-relaxed">{s.body}</p>
                </div>
              );
            })}
          </div>

          <div className="mt-12 bg-[#F1F5F9] border border-slate-200 p-8 lg:p-12 flex flex-col lg:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="text-2xl font-display font-bold text-[#1E2A78]">Need a custom quote?</h3>
              <p className="mt-2 text-slate-600">Tell us about your shipment and we'll respond within 24 hours.</p>
            </div>
            <div className="flex gap-3">
              <Link to="/pickup" data-testid="services-pickup-cta" className="px-6 py-3 bg-[#1E2A78] text-white font-semibold rounded-sm hover:bg-[#17205E] inline-flex items-center gap-2">
                Request Pickup <ArrowRight className="h-4 w-4" />
              </Link>
              <Link to="/contact" data-testid="services-contact-cta" className="px-6 py-3 bg-[#FFD700] text-[#1E2A78] font-semibold rounded-sm hover:bg-[#E6C200]">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
